import { LoanName } from "@appTypes/LoansApi.interface"

export function getDisplayLoanName(loanName: string): string {
    if (loanName === LoanName.SecuredLoan) {
      return 'Homeowner Loan'
    }
    return loanName
  }